'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _extends = require('../../extends-f8003900.js');
var objectWithoutProperties = require('../../objectWithoutProperties-aa43106a.js');
var React = require('react');
var index = require('../../index-0e40e0c2.js');
var formik_esm = require('../../formik.esm-b249f491.js');
var components_Typography_Typography = require('../Typography/Typography.js');
var components_FieldErrorMessage_FieldErrorMessage = require('../FieldErrorMessage/FieldErrorMessage.js');
var FormContext = require('../../FormContext-e45f4589.js');
var components_Icon_Icon = require('../../Icon-97784f8d.js');
var validateField = require('../../validateField-179f14cb.js');
var xstyledStyledComponents_es = require('../../xstyled-styled-components.es-02f83f64.js');
var styles_themeUtils = require('../../styles/themeUtils.js');
require('../../styles/colors/colorVariantsShape.js');
require('../../colorBuilder-0e3465cf.js');
require('../../polished.esm-0312677e.js');
require('../../utils/hooks/useIntlAriaAttrs.js');
require('../NuDSProvider/NuDSProvider.js');
require('../../breakpoints-7bb24b2d.js');
require('../../unsupportedIterableToArray-a6f9513d.js');
require('../../utils/logger/logDeprecatedFeature/logDeprecatedFeature.js');
require('../../utils/env/isBrowserEnv/isBrowserEnv.js');
require('../../utils/env/isTestEnv/isTestEnv.js');
require('../../utils/env/isProdEnv/isProdEnv.js');
require('../GlobalStyle/GlobalStyle.js');
require('styled-components');
require('../../theme-340a6118.js');
require('../../utils/intl/intlAriaAttrs.js');
require('../../utils/i18n/maybeFormatPrefixedMessage.js');
require('../../utils/i18n/maybeFormatMessage.js');
require('../../defineProperty-3cad0327.js');
require('../../xstyled-prop-types.es-56667676.js');
require('../../utils/isType/isType.js');
require('../../slicedToArray-e6d9072a.js');
require('../../utils/string/isString.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _templateObject$3, _templateObject2$2;
var Label = xstyledStyledComponents_es.styled.label(_templateObject$3 || (_templateObject$3 = xstyledStyledComponents_es.taggedTemplateLiteral(["\n  cursor: pointer;\n  position: relative;\n  display: block;\n  color: ", ";\n"])), styles_themeUtils.nuDSColor('black', 'defaultT70'));
Label.displayName = 'Label';
var LabelText = xstyledStyledComponents_es.styled.div(_templateObject2$2 || (_templateObject2$2 = xstyledStyledComponents_es.taggedTemplateLiteral([""])));
LabelText.displayName = 'LabelText';

var _templateObject$2, _templateObject2$1, _templateObject3;
var floatingLabelCSS = xstyledStyledComponents_es.css(_templateObject$2 || (_templateObject$2 = xstyledStyledComponents_es.taggedTemplateLiteral(["\n  transform: scale(.84) translateY(-25px);\n"])));

var validationColor = function validationColor() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$defaultColorName = _ref.defaultColorName,
      defaultColorName = _ref$defaultColorName === void 0 ? 'black' : _ref$defaultColorName,
      _ref$colorVariation = _ref.colorVariation,
      colorVariation = _ref$colorVariation === void 0 ? 'default' : _ref$colorVariation;

  return function (_ref2) {
    var touched = _ref2.touched,
        hasError = _ref2.hasError,
        hasValidation = _ref2.hasValidation;

    if (!touched || !hasValidation) {
      return styles_themeUtils.nuDSColor(defaultColorName, colorVariation);
    }

    if (hasError) {
      return styles_themeUtils.nuDSColor('error');
    }

    return styles_themeUtils.nuDSColor('success');
  };
};

var validationBorderOnInteraction = function validationBorderOnInteraction(_ref3) {
  var touched = _ref3.touched,
      hasValidation = _ref3.hasValidation;
  return (!hasValidation || !touched) && xstyledStyledComponents_es.css(_templateObject2$1 || (_templateObject2$1 = xstyledStyledComponents_es.taggedTemplateLiteral(["\n  border-bottom-color: ", ";\n"])), styles_themeUtils.nuDSColor('black'));
};

var Input = xstyledStyledComponents_es.styled(components_Typography_Typography['default'])(_templateObject3 || (_templateObject3 = xstyledStyledComponents_es.taggedTemplateLiteral(["\n  background-color: transparent;\n  border: 0;\n  border-radius: 0;\n  box-sizing: border-box;\n  color: ", ";\n  caret-color: currentColor;\n  display: block;\n  margin: 0;\n  padding: 8px 0;\n  ", "\n  ", "\n  text-align: left;\n  outline: none;\n  width: 100%;\n  border-bottom: 1px solid ", ";\n  --inputCurrentColor: ", ";\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n\n  &:focus, &:hover {\n    ", ";\n  }\n\n  & + ", " {\n    transition: 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n    transition-property: transform, color;\n    will-change: transform, color;\n    transform-origin: 0% 0%;\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    pointer-events: none;\n    font-size: 1rem;\n    min-height: 1rem;\n    height: auto;\n    white-space: nowrap;\n    display: flex;\n    align-items: center;\n    ", "\n    ", ";\n  }\n\n  &::placeholder {\n    color: ", ";\n  }\n\n  &:focus + ", " {\n    ", "\n  }\n"])), validationColor(), function (_ref4) {
  var hasStartIcon = _ref4.hasStartIcon;
  return hasStartIcon && 'padding-left: 24px;';
}, function (_ref5) {
  var hasEndIcon = _ref5.hasEndIcon;
  return hasEndIcon && 'padding-right: 24px;';
}, validationColor({
  colorVariation: 'defaultT20'
}), validationColor(), validationBorderOnInteraction, LabelText, function (_ref6) {
  var hasStartIcon = _ref6.hasStartIcon;
  return hasStartIcon && 'margin-left: 24px;';
}, function (_ref7) {
  var value = _ref7.value,
      hasPlaceholder = _ref7.hasPlaceholder;
  var hasValue = value && value.length;
  return (hasValue || hasPlaceholder) && floatingLabelCSS;
}, styles_themeUtils.nuDSColor('black', 'defaultT70'), LabelText, floatingLabelCSS);
Input.defaultProps = {
  tag: 'input',
  variant: 'subtitle1',
  strong: true
};
Input.propTypes = {
  hasEndIcon: index.PropTypes.bool.isRequired,
  hasError: index.PropTypes.bool.isRequired,
  hasStartIcon: index.PropTypes.bool.isRequired,
  hasValidation: index.PropTypes.bool.isRequired,
  touched: index.PropTypes.bool.isRequired
};
Input.displayName = 'Input';

var _templateObject$1;
var TextFieldGroup = xstyledStyledComponents_es.styled.div(_templateObject$1 || (_templateObject$1 = xstyledStyledComponents_es.taggedTemplateLiteral(["\n  font-size: 1rem;\n  max-width: 100%;\n  padding: 1rem 0;\n  position: relative;\n  min-height: 96px;\n"])));
TextFieldGroup.displayName = 'TextFieldGroup';

var _templateObject, _templateObject2;

var iconStyles = function iconStyles() {
  return "\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  margin: auto;\n  display: inline-block;\n  width: 16px;\n  height: 16px;\n\n  svg {\n    width: inherit;\n    height: inherit;\n    fill: currentColor;\n    cursor: default;\n  }\n";
};

var StartIcon = xstyledStyledComponents_es.styled.span(_templateObject || (_templateObject = xstyledStyledComponents_es.taggedTemplateLiteral(["\n  ", ";\n  left: 0;\n"])), iconStyles);
StartIcon.displayName = 'StartIcon';
var EndIcon = xstyledStyledComponents_es.styled.span(_templateObject2 || (_templateObject2 = xstyledStyledComponents_es.taggedTemplateLiteral(["\n  ", ";\n  right: 0;\n"])), iconStyles);
EndIcon.displayName = 'EndIcon';

function renderEndIcon(isTouched, hasEndIcon, hasValidation) {
  if (!hasEndIcon) {
    return false;
  }

  if (!hasValidation) {
    return true;
  }

  return !isTouched;
}

var TextField = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var id = _ref.id,
      label = _ref.label,
      name = _ref.name,
      syncValidations = _ref.syncValidations,
      endIcon = _ref.endIcon,
      startIcon = _ref.startIcon,
      onBlur = _ref.onBlur,
      props = objectWithoutProperties.objectWithoutProperties(_ref, ["id", "label", "name", "syncValidations", "endIcon", "startIcon", "onBlur"]);

  var validations = FormContext.useFormValidations();

  var _useFormData = FormContext.useFormData(),
      formsValues = _useFormData.formsValues;

  var _useContext = React.useContext(formik_esm.FormikContext),
      values = _useContext.values;

  var errorMessageId = "error-".concat(name);
  var labelId = "label-".concat(name);
  var isRequired = Boolean(syncValidations.required);
  var hasStartIcon = Boolean(startIcon);
  var hasEndIcon = Boolean(endIcon);
  var hasValidation = Boolean(Object.keys(syncValidations).length);
  return /*#__PURE__*/React__default['default'].createElement(formik_esm.Field, {
    name: name,
    validate: validateField.validateField(validations, syncValidations, _extends._extends({}, formsValues, values))
  }, function (_ref2) {
    var field = _ref2.field,
        meta = _ref2.meta;
    var handleOnBlur = React.useCallback(function (event) {
      field.onBlur(event);
      onBlur(event);
    }, [field.onBlur, onBlur]);
    var hasError = Boolean(meta.error);
    var isTouched = Boolean(meta.touched);

    var a11yProps = _extends._extends({
      'aria-required': isRequired,
      'aria-invalid': hasError,
      'aria-labelledby': labelId
    }, hasError && {
      'aria-describedby': errorMessageId
    });

    return /*#__PURE__*/React__default['default'].createElement(TextFieldGroup, null, /*#__PURE__*/React__default['default'].createElement(Label, {
      htmlFor: id,
      id: labelId
    }, hasStartIcon && /*#__PURE__*/React__default['default'].createElement(StartIcon, null, startIcon), /*#__PURE__*/React__default['default'].createElement(Input, _extends._extends({}, a11yProps, field, props, {
      hasStartIcon: hasStartIcon,
      hasEndIcon: hasEndIcon || isTouched && hasValidation,
      hasError: hasError,
      hasValidation: hasValidation,
      hasPlaceholder: Boolean(props.placeholder),
      touched: isTouched,
      id: id,
      ref: ref,
      required: isRequired,
      onBlur: handleOnBlur
    })), /*#__PURE__*/React__default['default'].createElement(LabelText, null, /*#__PURE__*/React__default['default'].createElement(components_Typography_Typography['default'], {
      tag: "span",
      variant: "paragraph2",
      strong: true
    }, label)), renderEndIcon(isTouched, hasEndIcon, hasValidation) && /*#__PURE__*/React__default['default'].createElement(EndIcon, null, endIcon), isTouched && hasValidation && /*#__PURE__*/React__default['default'].createElement(EndIcon, null, hasError ? /*#__PURE__*/React__default['default'].createElement(components_Icon_Icon.Icon, {
      name: "x-circle",
      title: "Invalid Icon",
      color: "error"
    }) : /*#__PURE__*/React__default['default'].createElement(components_Icon_Icon.Icon, {
      name: "check-circle",
      title: "Valid Icon",
      color: "success"
    }))), /*#__PURE__*/React__default['default'].createElement(components_FieldErrorMessage_FieldErrorMessage['default'], {
      name: name,
      errorMessageId: errorMessageId
    }));
  });
});
TextField.defaultProps = {
  endIcon: undefined,
  onBlur: function onBlur() {},
  syncValidations: {},
  startIcon: undefined,
  placeholder: undefined
};
TextField.propTypes = {
  endIcon: index.PropTypes.node,
  id: index.PropTypes.string.isRequired,
  label: index.PropTypes.string.isRequired,
  name: index.PropTypes.string.isRequired,
  onBlur: index.PropTypes.func,
  placeholder: index.PropTypes.string,
  startIcon: index.PropTypes.node,
  syncValidations: index.PropTypes.objectOf(index.PropTypes.any)
};

exports.default = TextField;
//# sourceMappingURL=TextField.js.map
